import { render, staticRenderFns } from "./cms-component-text.vue?vue&type=template&id=4e3d7094"
import script from "./cms-component-text.vue?vue&type=script&lang=js"
export * from "./cms-component-text.vue?vue&type=script&lang=js"
import style0 from "./cms-component-text.vue?vue&type=style&index=0&id=4e3d7094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports